<div class="navbar fixed top-0 z-10 w-full max-w-[480px] bg-base-100">
  <div class="navbar-start w-[80px] cursor-pointer">
    @if (isLogin$ | async) {
      <market-header-location />
    }
  </div>
  <div class="navbar-center flex flex-1 justify-center">
    <a class="btn btn-ghost text-xl normal-case" href="/market"
      >Nutriday Shop</a
    >
  </div>
  <div class="navbar-end w-[105px] gap-1">
    <a class="btn btn-circle btn-ghost btn-sm" [routerLink]="['/products']">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
    </a>
    @if (isLogin$ | async) {
      <market-header-notification />
      <market-header-qr />
    } @else {
      <a class="btn btn-circle btn-ghost btn-sm" href="/auth/n01">
        Đăng nhập/Đăng ký
      </a>
    }
  </div>
</div>
